import { render, staticRenderFns } from "./DriveUploaderForm.vue?vue&type=template&id=0d55df80"
import script from "./DriveUploaderForm.vue?vue&type=script&lang=ts"
export * from "./DriveUploaderForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports